export const GAME_BACKUP_FORMAT = 'melodia.dungeon-market.backup';
export const GAME_BACKUP_VERSION = 1;
export const MAX_BACKUP_BYTES = 2 * 1024 * 1024;

function cleanGameState(state) {
  const {
    cloudSync: _cloudSync,
    saveRevision: _saveRevision,
    saveWriterId: _saveWriterId,
    ...localState
  } = state;
  return localState;
}

export function createGameBackup(state, now = Date.now()) {
  if (!state || typeof state !== 'object' || Array.isArray(state)) {
    throw new TypeError('A valid Dungeon Market ledger is required.');
  }
  return {
    format: GAME_BACKUP_FORMAT,
    formatVersion: GAME_BACKUP_VERSION,
    exportedAt: new Date(now).toISOString(),
    game: cleanGameState(state),
  };
}

export function serializeGameBackup(state, now = Date.now()) {
  return `${JSON.stringify(createGameBackup(state, now), null, 2)}\n`;
}

export function parseGameBackup(raw) {
  if (typeof raw !== 'string' || !raw.trim()) {
    return { ok: false, error: 'This backup file is empty.' };
  }
  if (new TextEncoder().encode(raw).byteLength > MAX_BACKUP_BYTES) {
    return { ok: false, error: 'This backup is larger than Dungeon Market can safely restore.' };
  }

  let backup;
  try {
    backup = JSON.parse(raw);
  } catch {
    return { ok: false, error: 'This file is not valid JSON.' };
  }
  if (!backup || typeof backup !== 'object' || Array.isArray(backup)) {
    return { ok: false, error: 'This is not a Dungeon Market backup.' };
  }
  if (backup.format !== GAME_BACKUP_FORMAT) {
    return { ok: false, error: 'This backup belongs to another game or format.' };
  }
  if (backup.formatVersion !== GAME_BACKUP_VERSION) {
    return { ok: false, error: 'This backup version is not supported yet.' };
  }
  if (!backup.game || typeof backup.game !== 'object' || Array.isArray(backup.game)) {
    return { ok: false, error: 'This backup does not contain a valid game ledger.' };
  }
  if (!Number.isInteger(backup.game.version) || backup.game.version < 1) {
    return { ok: false, error: 'This backup is missing its game version.' };
  }
  const exportedAt = Date.parse(backup.exportedAt);
  if (!Number.isFinite(exportedAt)) {
    return { ok: false, error: 'This backup is missing a valid export date.' };
  }

  return {
    ok: true,
    exportedAt,
    game: cleanGameState(backup.game),
  };
}
